export const TEXT_KEYS = {
    REDEEM_MAIN_PAGE_ERROR: 'platform-selection__error',
    REDEEM_MAIN_PAGE_LINKING_ERROR: 'platform-selection__account-linking-error',
    REDEEM_CODE_ERROR: 'redeem-code__invalid-code'
};
